import React, { useState } from 'react';
import { X, Delete } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';

const KeypadModal = ({ isOpen, onClose, onSubmit, title = 'Enter PIN' }) => {
  const [pin, setPin] = useState('');

  const handleNumberClick = (num) => {
    if (pin.length < 6) {
      setPin(pin + num);
    }
  };

  const handleDelete = () => {
    setPin(pin.slice(0, -1));
  };

  const handleSubmit = () => {
    if (pin.length >= 4) {
      onSubmit(pin);
      setPin('');
    }
  };

  const handleClose = () => {
    setPin('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-xl">{title}</DialogTitle>
          <DialogDescription className="text-center">
            Enter your 4-6 digit PIN code
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          <div className="flex justify-center">
            <div className="flex space-x-2">
              {[0, 1, 2, 3, 4, 5].map(i => (
                <div
                  key={i}
                  className="w-12 h-12 rounded-lg border-2 flex items-center justify-center text-2xl font-bold"
                  style={{
                    borderColor: pin.length > i ? '#F26724' : '#E5E7EB',
                    backgroundColor: pin.length > i ? '#FEF3F2' : 'white'
                  }}
                >
                  {pin[i] ? '•' : ''}
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-3 gap-3">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (
              <Button
                key={num}
                onClick={() => handleNumberClick(num.toString())}
                variant="outline"
                className="h-16 text-2xl font-semibold hover:bg-gray-50 transition-colors"
              >
                {num}
              </Button>
            ))}
            <Button
              onClick={handleDelete}
              variant="outline"
              className="h-16 hover:bg-red-50 transition-colors"
            >
              <Delete size={24} />
            </Button>
            <Button
              onClick={() => handleNumberClick('0')}
              variant="outline"
              className="h-16 text-2xl font-semibold hover:bg-gray-50 transition-colors"
            >
              0
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={pin.length < 4}
              className="h-16 text-lg font-semibold"
              style={{ backgroundColor: '#F26724' }}
            >
              OK
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default KeypadModal;
